import api from 'ApiConfig';

const testService = {
  createCourse: async (data) => {
    return api.post('/admin/create-course', data);
  },
  getAllTests: async (data) => {
    return api.post('/teacher/all-tests', data);
  },
  testByTeacherCourse: async (courseId) => {
    return api.post('/teacher/get-test-by-teacher-course', { courseId });
  },
  testByBatchStructure: async (structureId) => {
    return api.post('/teacher/get-test-by-batch-structure', { structureId });
  },

  getAllCourses: async (selectedBranch) => {
    return api.post('/teacher/get-all-course', { selectedBranch });
  },
  getBatchesByCourse: async (courseId) => {
    return api.post('/teacher/get-course-by-courseId', { courseId });
  },

  createTest: async (data) => {
    return api.post('/teacher/create-test', data);
  },

  assignTestToBatches: async (payload) => {
    return api.post('/teacher/assign-test', payload);
  },

  assignRetestToStudents: async (payload) => {
    return api.post('/teacher/assign-retest-student', payload);
  },
  assigntestToSingleStudents: async (payload) => {
    return api.post('/teacher/assign-test-single-student', payload);
  },
  viewAttendedTestsByTeacher: async () => {
    return api.post('/teacher/view-attended-test-to-teacher');
  },
  viewAttendedAssignmentsByTeacher: async () => {
    return api.post('/teacher/view-attended-assignmet-to-teacher');
  },

  submitQATestScores: async (data) => {
    return api.post('/teacher/submit-qa-test-score', data);
  },
  submitAssignmentQAsScores: async (submissionId, totalScore) => {
    return api.post(
      '/teacher/submit-assignment-score',
      submissionId,
      totalScore
    );
  },
  getCreatedTests: async () => {
    return api.post('/teacher/get-created-test');
  },
  getTestsByBatch: async (data) => {
    return api.post('/teacher/get-tests-by-batch', data);
  },
  getSubmissionsByTestId: async (testId) => {
    return api.post('/teacher/get-submission-by-testid', { testId });
  },
  getTestsScheduleDate: async () => {
    return api.post('/teacher/get-test-schedule-date');
  },
  getAllFailedStudents: async ({ courseId, batchId }) => {
    return api.post('/teacher/get-all-failed-students', { courseId, batchId });
  },
};
export default testService;
